var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center"},[_c('p',{staticClass:"my-0"},[_vm._v(" © "+_vm._s(_vm.year)+" Forjado por "),_c('a',{staticClass:"font-weight-bold",attrs:{"href":"https://wize.pe/","target":"_blank"}},[_vm._v("Wize")])])])}
var staticRenderFns = []

export { render, staticRenderFns }